import { render, staticRenderFns } from "./ProdutividadeMecanico.vue?vue&type=template&id=b0dfcc16&scoped=true&"
import script from "./ProdutividadeMecanico.vue?vue&type=script&lang=js&"
export * from "./ProdutividadeMecanico.vue?vue&type=script&lang=js&"
import style0 from "./ProdutividadeMecanico.vue?vue&type=style&index=0&id=b0dfcc16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dfcc16",
  null
  
)

export default component.exports